import './country.scss'
import React, {useEffect, useState} from "react";
import {useStateContext} from "../../helpers/state-context.js";
import {ModelCountriesMain} from "../../models/country.js";
import {ModelConsumer} from "../../helpers/model/model-consumer.js";
import {CountryHeader} from "./header.js";
import {CountryBox} from "./box.js";
import {Info} from "../info-share/info.js";
import {categoriesMapping} from "../categories/categories_mapping.js";
import {ReactComponent as IconBell} from '../../assets/bell.svg';

function Country() {
    const [state, dispatch] = useStateContext(['page', 'country', 'selectedCategory']);
    const [showInfo,setShowInfo] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            const container = document.getElementsByClassName('country-box');
            const header = document.getElementsByClassName('country-header');
            const moreButtons = document.getElementById('more-buttons');
            const wrapper = document.getElementsByClassName('country-wrapper')[0];

            const isOutside = [...container, ...header, moreButtons].every((box)=>(box && !box.contains(e.target)));
            if(isOutside && wrapper){
                e.stopPropagation();
                dispatch({type: 'countryHover', value: null});
                dispatch({type: 'country', value: null});
                dispatch({type: 'page', value: null});
                dispatch({type: 'setDefaultCategories'});
            }

        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        }
    }, [dispatch, state]);


    if (state.country) {
        return <ModelConsumer model={ModelCountriesMain}>
            {(resultSet)=>{
               const country = resultSet.data.raw.find((country)=>country.country_code === state.country);
               if(showInfo){
                   return <Info expanded={[false,false, true,false]} onClose={()=>{setShowInfo(false)}}/>
               }
               if(country){
                   const categories = [];
                   for(const [key, category] of categoriesMapping.entries()){
                       if(country[`category_${category.id}`] === true){
                           // If category 8 is true while there are other categories selected aswell skip category 8.
                           if(key === 7 && country.category_8 === true && categories.length > 0){
                               break;
                           }

                           categories.push(category.id)
                       }
                   }
                   return <div className={'country-wrapper'}>
                       <div className={'country-container'}>
                           <CountryHeader title={country.country_name}/>
                           <div className={'country'}>
                               <div style={{flex: .7}}>
                                   <CountryBox data={country.text}/>
                                   <CountryBox title={'Useful information'} data={country.useful_information}/>
                                   <CountryBox data={country.permits_foundation_activity}
                                        title={`Permits Foundation activity in ${country.country_name}`}
                                        type={'horizontal_list'}/>
                               </div>
                               <div style={{flex: .3}}>
                                   <CountryBox data={country.image}
                                           type={'image'}
                                           caption={country.image_caption}/>
                                   <CountryBox data={categories} type={'categories'}/>
                                   {country.is_pf_active_in_this_country? 
                                        <CountryBox type="active">
                                            <span style={{cssFloat: 'left', margin: '5px 10px 0px 0px'}}>
                                                <IconBell width="40" height="40"/>
                                            </span>
                                            Permits Foundation is actively engaging in this country
                                        </CountryBox>: 
                                        null
                                    }
                                   <CountryBox data={country.quote} type="quote" />
                                   <CountryBox >
                                       <span className={'link'} onClick={()=>{
                                           dispatch({type: 'countryHover', value: null});
                                           dispatch({type: 'setDefaultCategories'});
                                           dispatch({type: 'infoExpanded', value: [false, false, true, false]})
                                           dispatch({type: 'setValues', value: {country: null, page: 'more-info'}})
                                          }}
                                          style={{cursor: 'pointer'}}>
                                           Legal disclaimer
                                       </span>
                                   </CountryBox>
                                   {country.last_updated_on && country.last_updated_on.trim() !== '' ? 
                                        <CountryBox data={country.last_updated_on} type={'last-updated'}/> :
                                        null
                                    }
                               </div>
                           </div>
                       </div>
                   </div>
               }
            }}
        </ModelConsumer>
    }
    return <></>
}

export {Country}